import IcHome from './IcHome'
export default IcHome
